import React from "react";
import { useNavigate } from "react-router-dom";
import { DialogControl } from "spark-core-dx/components";
import { buildResourceConfigurePath } from "../../resource/resourceRoutes";

const statusLabels = {
  1: "Draft",
  2: "Configuring",
  3: "Pending review",
  4: "Active",
  5: "Failed",
  6: "Retired",
  7: "Configured"
};

const getClientResourceId = (clientResource) =>
  clientResource?._id || clientResource?.id || clientResource?.UniqueId || "";

const getConfigurationId = (configuration) =>
  configuration?._id || configuration?.id || configuration?.UniqueId || "";

const formatDate = (value) => {
  if (!value) return "Not updated";
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? "Not updated" : parsed.toLocaleString();
};

const getGrantLabel = (configuration) => {
  const offerSku = configuration?.allowanceProductOfferSku || configuration?.AllowanceProductOfferSku;
  const offerKey = configuration?.allowanceProductOfferKey || configuration?.AllowanceProductOfferKey;
  const grantKey = configuration?.allowanceGrantProductResourceKey || configuration?.AllowanceGrantProductResourceKey;
  return offerSku || offerKey || grantKey || "Unassigned";
};

const MarketplaceConfigurationChooserDialog = ({
  open = false,
  resource = null,
  clientResource = null,
  configurations = [],
  onClose
}) => {
  const navigate = useNavigate();
  const clientResourceId = getClientResourceId(clientResource);
  const newConfigurationPath = clientResourceId ? `${buildResourceConfigurePath(clientResourceId)}?new=1` : "";

  const openPath = (path) => {
    if (!path) return;
    onClose?.();
    navigate(path);
  };

  const handleNewConfiguration = () => {
    openPath(newConfigurationPath);
    return { Success: Boolean(newConfigurationPath) };
  };

  if (!open) {
    return null;
  }

  return (
    <DialogControl
      openDialog={open}
      title={resource?.name ? `Configure - ${resource.name}` : "Resource configurations"}
      subTitle="Select an existing configuration or start a new one for this allowance."
      cancelText="Cancel"
      customCenterText="New Configuration"
      onCustomCenter={handleNewConfiguration}
      disabledCustomCenter={!newConfigurationPath}
      onCancel={onClose}
      onX={onClose}
      className="marketplace-dialog-control marketplace-config-dialog-control"
      innerclassName="marketplace-dialog-control__inner"
      controlOrigin="marketplace-configuration-chooser"
    >
        <div className="marketplace-config-dialog__list">
          {configurations.map((configuration) => {
            const configurationId = getConfigurationId(configuration);
            const status = Number(configuration.configurationStatus ?? configuration.ConfigurationStatus ?? 0);
            return (
              <button
                type="button"
                key={configurationId}
                className="marketplace-config-dialog__row"
                onClick={() => openPath(buildResourceConfigurePath(clientResourceId, configurationId))}
              >
                <span>
                  <strong>{configuration.displayName || configuration.DisplayName || resource?.name || "Resource configuration"}</strong>
                  <small>{getGrantLabel(configuration)}</small>
                </span>
                <span>{statusLabels[status] || "Unknown"}</span>
                <span>{formatDate(configuration.updatedDate || configuration.UpdatedDate || configuration.modifiedDate || configuration.ModifiedDate)}</span>
              </button>
            );
          })}
          {configurations.length === 0 ? (
            <div className="marketplace-dialog-control__empty">No configurations exist for this resource yet.</div>
          ) : null}
        </div>

    </DialogControl>
  );
};

export default MarketplaceConfigurationChooserDialog;
